import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProductPipesModule } from '@product/utils';
import { CustomDecimalPipeModule, DistanceFromYouPipe } from '@sdvor/shared/ui';
import { Pos } from '@shop/const';
import { ShopWorkingTimeComponent } from '../../../shop-working-time';

@Component({
  selector: 'sd-active-placemark',
  standalone: true,
  imports: [ShopWorkingTimeComponent, DistanceFromYouPipe, CommonModule, ProductPipesModule, CustomDecimalPipeModule],
  templateUrl: './active-placemark.component.html',
  styleUrls: ['./active-placemark.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomSheetActivePlacemarkComponent {
  readonly shop = input.required<Pos>();
  readonly showAvailability = input<boolean>(false);
}
